<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="月结账单审批" left-arrow fixed @click-left="back"/>
        <van-tabs v-model="tabActive" class="appr-tabs" >
            <van-tab title="账单信息">
                <van-cell-group title="审批信息">
                    <van-cell title="月结时间" :value="milkInfo.importTime" />
                    <van-cell title="审批状态" :value="milkInfo.statusName" />
                    <van-cell title="创建时间" :value="milkInfo.createtime" />
                    <van-cell title="审批意见" :value="milkInfo.remark" />
                </van-cell-group>
                <van-cell-group title="账单明细">
                    <van-cell title="支付状态" :value="milkInfo.payStatusName" />
                    <van-cell title="支付方式" :value="milkInfo.payTypeName" />
                    <van-cell title="已还款金额" :value="milkInfo.paidAmount" />
                    <van-cell title="待还款金额" :value="milkInfo.waitingRepayment" />
                    <van-cell title="待审核金额" :value="milkInfo.confirmedAmount" />
                    <van-cell title="上月欠款金额" :value="milkInfo.lastMonthArrear" />
                    <van-cell title="本月已还款金额" :value="milkInfo.thisMonthReturn" />
                    <van-cell title="累计欠款金额" :value="milkInfo.thisMonthArrear" />
                </van-cell-group>
            </van-tab>
            <van-tab title="还款明细">
                <van-collapse v-model="payDetailActive" accordion  v-if="milkInfo.payType==2">
                    <van-collapse-item :title="unlinePayItem.bankWater" :name="unlinePayItemIndex" :key="unlinePayItemIndex" v-for="(unlinePayItem,unlinePayItemIndex) in unlinePayDetails">
                        <van-cell title="还款时间" :value="unlinePayItem.createtime" />
                        <van-cell title="还款金额" :value="unlinePayItem.bankWaterMoney"  />
                        <van-cell title="审批状态" :value="unlinePayItem.workflowStatus==1?'审核成功':'待审核'"  />
                        <van-cell title="审批意见" :value="unlinePayItem.remark"  />
                    </van-collapse-item>
                </van-collapse>
                <van-collapse v-model="payDetailActive" accordion  v-if="milkInfo.payType!=2">
                    <van-collapse-item :title="payItem.payCode" :name="payIndex" :key="payIndex" v-for="(payItem,payIndex) in payDetails">
                        <van-cell title="还款时间" :value="payItem.createtime" />
                        <van-cell title="还款金额" :value="payItem.actualPayAmount"  />
                        <van-cell title="支付状态" :value="payItem.status==null?'待支付':'支付成功'"  />
                    </van-collapse-item>
                </van-collapse>
            </van-tab>


        </van-tabs>


    </div>
</template>
<script>
    import {
        NavBar, Cell, CellGroup, Field, Button, Row, Col, Collapse, CollapseItem, Tabs, Tab, Switch, Picker,
        Popup, RadioGroup, Radio, DatetimePicker, Dialog, Uploader
    } from "vant";

    export default {
        name: "ApprovalDetail",
        components: {
            [Dialog.name]: Dialog,
            [DatetimePicker.name]: DatetimePicker,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [Switch.name]: Switch,
            [Uploader .name]: Uploader ,
        },
        data() {
            return {
                payDetailActive:[],//支付详情
                importConfirmId:0,
                milkInfo:{},//账单信息
                payDetails:[],//还款支付信息
                unlinePayDetails:[],
                tabActive:0,
            }

        },
        mounted() {
            this.importConfirmId=localStorage.getItem("workflowImportConfirmId")
            this.loadDetail();
        },
        methods: {
            loadDetail(){
                let that = this;
                that.$api.get(that.jumuc.milk.milkReturnMoneyDetail, {
                    importConfirmId:that.importConfirmId
                },res =>{
                    if(res.success){
                        that.milkInfo=res.data.mainMilkInfo;
                        that.payDetails=res.data.payDetails;
                        that.unlinePayDetails=res.data.unlinePayDetails;
                    }
                })},

            back(){
                history.back();
            },


        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;
    body {
        background: #f7f7ff;
    }

    #app .van-tabs__line {
        height: 45px;
        background-color: rgba(255, 255, 255, 0.1);
        min-width: 80px;
        left: 0;
    }

    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }
</style>
